import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import { StatusAlertModal } from "./StatusAlertModal";
import './MoneyTransfer.css';
import swal from 'sweetalert';
// import './Subtransaction.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { setAmount, setCreateOrderRes, setMoneyTransferSurChargeAmount } from "../../redux/misc-data/misc-data.action";
import { setMoneyTransferTotalAmount } from "../../redux/misc-data/misc-data.action";
import { showCreateOrderResponse, showCreateOrderResponseArr } from './../../redux/response/response.action';
import { setOrderId } from './../../redux/order-details/order-details.action';
// import ProgressGif from '../../assests/images/progress.gif';
import ProgresStatic from '../../assests/images/mtimg.png';
import { setCreteOrderReq } from './../../redux/misc-data/misc-data.action';
import BankLogo from "../../assests/images/bank-logo.png";
import Avatar from 'react-avatar';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import { Link } from "react-router-dom";
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();
class MoneyTransfer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			amount: 0,
			statusEnquiryAttempCount: 0,
			createOrderResponseArr: [],
			currentRequestId: null,
			progressStatus: false,

			originalAmout: '',
			orderAmount: '',
			calculatePricingFiledLock: false,

			displayErrorMsg: '',
			transfernowBtnBlock: false,
			moneyTransferEnable: true,
			showStatusModal: false,
			displayStatusMsg: ''
		}
	}



	calculatePricing(event) {

		event.preventDefault();
		this.setState({
			displayErrorMsg: ''
		})
		store.dispatch(setMoneyTransferTotalAmount(''));
		store.dispatch(setMoneyTransferSurChargeAmount(''));
		// if(parseInt(event.target.value>10)){



		if (parseInt(this.state.orderAmount) <= 10) {
			this.errorMessageCall('Entered amount must be greater than 10Rs. ')
		} else if (parseInt(this.state.orderAmount) > parseInt(this.props.customerLimit)) {
			this.errorMessageCall('Entered amount is more than customer available limit.')

		} else {
			this.setState({
				originalAmout: event.target.value,
				progressStatus: true
			})

			const header = {
				msgType: "CALCULATE_PRICING",
				service: "PRICING",
				// dstService:"CUSTOM_SERVICE",
				channel: "ADMIN",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),//filled by the 3rd party requester
				time: moment().utc(),
				traceId: uuidv4(),
			}

			var createOrderUrl = '/api/v1/pricing/calculate';

			const pricingReq = {
				header: header,
				entityId: this.props.clientRequesterId,
				entityType: "CUSTOMER",
				productTree:
				{
					serviceCode: "BANKING",
					categoryCode: "DMT",
					productCode: "PAYU"
				},
				txnAmount: parseFloat(this.state.orderAmount).toFixed(2)

			}
			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}

			console.log('pricing req:' + JSON.stringify(pricingReq));

			httpClient.post(createOrderUrl, pricingReq, {
				timeout: 60 * 1000,
				timeoutErrorMessage: 'timeout',
				headers
			}
			).then((response) => {
				this.setState({
					progressStatus: false,
					calculatePricingFiledLock: true

				})

				console.log('pricing response' + JSON.stringify(response.data));
				if (response.data.response.msg == 'SUCCESS') {

					console.log('pricing service response:' + JSON.stringify(response.data))
					store.dispatch(setAmount(event.target.velue));
					var totalAmount = parseInt(response.data.txnAmount) +
						parseInt(response.data.pricingAmount);
					store.dispatch(setMoneyTransferTotalAmount(totalAmount));
					store.dispatch(setMoneyTransferSurChargeAmount(response.data.pricingAmount));
					store.dispatch(showCreateOrderResponse(response.data));
					store.dispatch(setOrderId(response.data.pricingId));

					this.setState({
						transfernowBtnBlock: true
					})

				} else {
					this.errorMessageCall(response.data.response.displayMsg);
				}
			}).catch(error => {
				this.setState({
					progressStatus: false
				})
				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				} else if (error.message.includes("timeout")) {
					this.errorMessageCall('Request timed out.');
				} else {
					this.errorMessageCall(error.message);
				}

			})
		}
	}



	errorMessageCall = (message) => {
		this.setState({
			displayErrorMsg: message
		})
	}




	componentDidMount() {
		store.dispatch(setMoneyTransferTotalAmount(''));
		store.dispatch(setMoneyTransferSurChargeAmount(''));

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		var statusCheckUrl = '/api/v1/dmt/service/status';

		httpClient.get(statusCheckUrl, {
			headers
		}
		).then((response) => {


			console.log('status response' + JSON.stringify(response.data));
			if (response.data.response.success == true) {

				this.setState({
					moneyTransferEnable: true
				})

			} else {

				this.setState({
					moneyTransferEnable: false,
					showStatusModal: true,
					displayStatusMsg: response.data.response.displayMsg
				})


				swal({
					title: "Sorry!",
					text: response.data.response.displayMsg,
					icon: "warning",
					button: true,
					dangerMode: false,
				})
					.then(() => {
					});


			}

		}).catch(error => {
			this.setState({
				moneyTransferEnable: true
			})

			this.errorMessageCall(error.message);


		})
	}

	componentWillUnmount() {
	}

	handleClose = (event) => {
		event.preventDefault();
		this.setState({
			showStatusModal: false
		})
	}



	unlockAmountEdit = (event) => {

		this.setState({
			calculatePricingFiledLock: false,
			displayErrorMsg: ''
		})


		store.dispatch(setMoneyTransferTotalAmount(''));
		store.dispatch(setMoneyTransferSurChargeAmount(''));
	}


	enterAmount = (event) => {
		this.setState({
			orderAmount: event.target.value
		})
	}
	createOrder = (event) => {
		event.preventDefault();

		const header = {
			msgType: "CREATE_ORDER",
			service: "DMT",
			channel: "WHITELABEL",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),
			time: moment().utc(),

		};



		var customerId = this.props.selectSender.customer.id;



		const transaction = {
			mobile: this.props.selectSender.customer.mobile,
			customerId: customerId,
			amount: parseFloat(this.state.orderAmount).toFixed(2),
			operator: "IMPS"
		}

		const optional = {
			BENEFICIARY_ID: this.props.benefisciaryInfo.beneId,
		}

		var createOrderRequest = {
			header: header,
			device: this.props.deviceInfo,
			transaction: transaction,
			validated: true,
			payment: "PARTNER_BALANCE",
			agentId: this.props.agentInfo.id,
			optional: optional
		}



		var createOrderUrl = '/api/v1/dmt/order/create';

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('create order req:' + JSON.stringify(createOrderRequest));

		httpClient.post(createOrderUrl, createOrderRequest, {
			timeout: 60 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {


			console.log('create order response' + JSON.stringify(response.data));
			if (response.data.response.msg == 'ORDER_ACCEPTED') {

				store.dispatch(setCreteOrderReq(createOrderRequest));
				store.dispatch(setCreateOrderRes(response.data));


				var moneyransferDetails = document.getElementById('moneyransferDetails');
				moneyransferDetails.click();

			} else {
				this.errorMessageCall(response.data.response.displayMsg)
			}
		}).catch(error => {
			this.setState({
				progressStatus: false
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else if (error.message.includes("timeout")) {
				this.errorMessageCall('Request timed out.');
			} else {
				this.errorMessageCall(error.message);
			}
		})
	}





	render() {
		console.log(JSON.stringify(this.props.beneSubDetails));
		console.log('this.props.benefisciaryInfo..' + JSON.stringify(this.props.benefisciaryInfo));
		return (

			<div>
				<HeadeCommon />
				<Menu />
				<div class="main">
					<div class="right-side">
						<div class="container-fluid">
							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">

										<div class="head">
											<h3>Money Transfer</h3>
											<Link to='/dmt'>
												<button class="dbbtn" type="button">Back</button>
											</Link>
											<Link to='/money-transfer-details'>
												<button id='moneyransferDetails' hidden={true}></button>
											</Link>


										</div>

										<div class="benedtls">
											<div class="row justify-content-md-center">
												<div class="col-12 col-md-6 col-lg-4 order-lg-1">
													<div class="graycard">
														<div class="bankdtl">
															<Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" />
															<h5>Sender Name</h5>
															<p>{this.props.selectSender.customer.name}</p>
														</div>
														<hr />
														<div class="bankdtl">
															<h5>Mobile Number</h5>
															<p>{this.props.selectSender.customer.mobile}</p>
														</div>
													</div>
												</div>

												<div class="col-12 col-md-6 col-lg-4 order-lg-3">
													<div class="graycard">
														<div class="bankdtl">

															{(this.props.benefisciaryInfo.bankName != null && this.props.benefisciaryInfo.bankName != null &&
																this.props.bankLogoListTxt.includes(this.props.benefisciaryInfo.bankName.split(' ').join("-") + ".PNG")) ?
																<img src={'/bank_images/' + this.props.benefisciaryInfo.bankName.toLowerCase().split(' ').join("-") + ".png"} alt="bank" /> :
																<img src={BankLogo} alt="bank" />
															}

															<h5>{this.props.benefisciaryInfo.name}</h5>
															<p>{this.props.benefisciaryInfo.bankName}</p>
														</div>
														<hr />
														<div class="acntifsc">
															<h5>Account Number</h5>
															<p>{this.props.benefisciaryInfo.accountNumber}</p>
														</div>

														<div class="acntifsc rtxt">
															<h5>IFSC Code</h5>
															<p>{this.props.benefisciaryInfo.ifscCode}</p>
														</div>
													</div>
												</div>

												<div class="col-12 col-lg-4 order-lg-2">
													<div class="mtprogess d-none d-md-block">
														<img src={ProgresStatic} alt="process" class="img-fluid" />
													</div>

													<div class="form-floating input-group amtmrgn">
														{this.state.calculatePricingFiledLock == false &&
															<input type="number" class="form-control" id="amt" placeholder="Amount"
																min={1} max={99999} autoCorrect="true"
																onInput={(e) => e.target.value = e.target.value.slice(0, 5)}
																readOnly={this.state.moneyTransferEnable == false ? true : false}
																value={this.state.orderAmount}
																onChange={this.enterAmount} />
														}

														{this.state.calculatePricingFiledLock == true &&
															<input type="number" class="form-control" id="amt" placeholder="Amount"
																value={this.state.orderAmount}

																readOnly />
														}

														{this.state.calculatePricingFiledLock == true &&
															<button class="edtamt" type="button" onClick={this.unlockAmountEdit}
																data-bs-toggle="tooltip" title="Edit amount"></button>
														}

														<label for="amt">Enter Amount</label>
														{(this.props.surcharge == '' && this.props.transferTotalAmount == '') ?
															(this.state.orderAmount != ''
																&& this.state.moneyTransferEnable == true) ?
																<button type="button" class="btn btnmtr"
																	onClick={(e) => this.calculatePricing(e)}
																>Calculate</button> :
																<button type="button" class="btn btnmtr" disabled>Calculate</button>
															:
															<div></div>}
														{(this.props.surcharge != '') ?
															this.state.transfernowBtnBlock == true ?
																<button type="button" class="btn btnmtr"
																	onClick={(e) => this.createOrder(e)}
																>Transfer Now</button> :
																<button type="button" disabled class="btn btnmtr"
																>Transfer Now</button>
															: <div></div>

														}



														{this.state.displayErrorMsg != '' &&
															<div class='valid-error'>
																{this.state.displayErrorMsg}
															</div>}
													</div>
													{(this.props.surcharge != '' && this.props.transferTotalAmount != '') &&
														<div class="amtshow"
														// style="display:none;"
														>
															<div class="amntchrg">
																<p>Surcharge</p>
																<h5>₹ {this.props.surcharge}</h5>
															</div>
															<div class="dbtamt">
																<p>Total Amount</p>
																<h4>₹{this.props.transferTotalAmount}</h4>

															</div>
														</div>
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, moneyTransferResponseDetails, createOrderResponseDetails,
			agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
			transferTotalAmount, deviceInfo, customerLimit,
			customerId, bankLogoListTxt, callBackUrl } }
) => ({
	errorMessage, loginErrorMessage, phone, moneyTransferResponseDetails,
	createOrderResponseDetails, agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
	transferTotalAmount, deviceInfo, customerLimit,
	customerId, bankLogoListTxt, callBackUrl
});

export default connect(mapStateToProps, null)(MoneyTransfer);

